(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"), require("VueDemi"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender", "VueDemi", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-trade-idea-main/render"] = factory(require("FEGORender"), require("VueDemi"), require("FEGOWebapi"));
	else
		root["/fego/component/common-trade-idea-main/render"] = factory(root["FEGORender"], root["VueDemi"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 